import { render, staticRenderFns } from "./RecruiterPaymentForm.vue?vue&type=template&id=5596eed9&"
import script from "./RecruiterPaymentForm.vue?vue&type=script&lang=js&"
export * from "./RecruiterPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports